import Swal from 'sweetalert2'
import {WORK_TYPE_BOOKN, WORK_TYPE_ORDER} from '../app/modules/Wizard/WizardConstants'
// import {toAbsoluteUrl} from "../_metronic/_helpers"

/* OrderSheet */
export const confirmSwal = (data, workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  return Swal.fire({
    title: `${typeName} 하시겠습니까?`,
    html: `최종금액은 ${(
      data.price * (data.quantity ? data.quantity : 1) +
      (data.price_delivery ? data.price_delivery : 0)
    ).toLocaleString('ko-KR')}원입니다.<br/> ${typeName}하시겠습니까?`,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: `${typeName} 하기`,
    cancelButtonText: '취소',
    heightAuto: false,
  })
}

export const paymentSwal = (data) => {
  return Swal.fire({
    title: `결제 하시겠습니까?`,
    html: `최종금액은 ${(
      data.price * (data.quantity ? data.quantity : 1) +
      (data.price_delivery ? data.price_delivery : 0)
    ).toLocaleString('ko-KR')}원입니다.<br/> 결제 하시겠습니까?`,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: `결제 하기`,
    cancelButtonText: '취소',
    heightAuto: false,
  })
}

export const orderSwal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  return Swal.fire({
    title: `${typeName} 되었습니다.`,
    html: `감사합니다.<br/>하단에 보이는 계좌로 금액을 맞게 입금해주시면 ${typeName}이 완료됩니다.<br/>문의사항은 Q&A를 이용해주세요.<br/>${typeName}해주셔서 감사합니다.`,
    icon: 'success',
    heightAuto: false,
  })
}

export const cancelSwal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  return Swal.fire({
    title: `${typeName}을 취소하시겠습니까?`,
    html: `다시 ${typeName}을 원하시면 처음부터 이용가능합니다.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: '취소하기',
    cancelButtonText: '취소',
    heightAuto: false,
  })
}

export const orderCancelSwal = () => {
  return Swal.fire({
    title: '취소되었습니다.',
    icon: 'error',
    heightAuto: false,
    buttonsStyling: false,
    confirmButtonText: '확인',
    customClass: {
      confirmButton: 'btn font-weight-bold btn-primary',
    },
  })
}

// 주문서 접수
export const order5030Swal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  Swal.fire({
    title: `${typeName}서 접수`,
    html: `${typeName}서가 접수되었습니다. <br/>가격이 산정되면 ${typeName}이 가능합니다.<br/> <span class="text-danger">가격산정</span>까지 기다려주시길 바랍니다.`,
    icon: 'info',
    heightAuto: false,
  }).then()
}

// 확인 요청
export const order5040Swal = (message, workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  let html = `가격이 산정되었습니다. <br/> ${typeName}을 원하시면 <mark class='text-white bg-success'>${typeName}하기</mark>를 클릭해주세요.`
  if (message !== '' && message !== undefined) {
    // html +=
    //   "<br/><br/>" +
    //     "<div style=\"width: 100%; border-color:#a0a0a0; white-space: pre-wrap; text-align:left;\" readonly>" +
    //     "<img src='/media/svg/icons/Communication/Mail-notification.svg' alt=''>" +
    //     "<span>" +
    //     message +
    //     "</span>"
    //   "</div>";
    html += `<div style="text-align:left; margin-top: 10px; border: 2px solid #c1c2c6; padding: 5px 2px;" readonly>
          <img src='/media/svg/icons/Communication/Mail-notification.svg' alt='' style="animation-duration: 1.5s; animation-name: blink-effect; animation-iteration-count: infinite" > <strong>추가 메시지 꼭! 확인해주세요.</strong>
<!--          <i class="flaticon2-send text-dark" style="animation-duration: 1.5s; animation-name: blink-effect; animation-iteration-count: infinite;"></i> <strong>추가 메시지 꼭! 확인해주세요.</strong>-->
          <div style="white-space:pre-line;">${message}</div>
        </div>`
  }
  Swal.fire({
    title: '가격산정',
    html: html,
    icon: 'info',
    heightAuto: false,
  }).then()
}

// 확인 완료
export const order5050Swal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  Swal.fire({
    title: '입금요청',
    html: `하단에 보이는 계좌로 입금해주시면 ${typeName}이 최종 완료됩니다.`,
    icon: 'warning',
    heightAuto: false,
  }).then()
}

// 입금 확인
export const order5060Swal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  const typeName2 = workType === 'ORDER' ? '픽업' : WORK_TYPE_BOOKN
  Swal.fire({
    title: `${typeName}완료`,
    html: `${typeName}이 완료되었습니다.<br/> ${typeName2}날짜에 뵙겠습니다. <br/> 감사합니다.`,
    icon: 'info',
    heightAuto: false,
  }).then()
}

// 주문 취소
export const order5070Swal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  Swal.fire({
    title: `취소 ${typeName}`,
    html: `취소된 ${typeName}입니다.<br/> 다시 ${typeName}해주시길 바랍니다.<br/> 감사합니다.`,
    icon: 'error',
    heightAuto: false,
  }).then()
}

/* WizardBody */
export const orderReceiptSwal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  return Swal.fire({
    title: `${typeName}하시겠습니까?`,
    icon: 'info',
    showCancelButton: true,
    buttonsStyling: false,
    confirmButtonText: `${typeName}하기`,
    cancelButtonText: '취소하기',
    customClass: {
      confirmButton: 'btn font-weight-bold btn-primary',
      cancelButton: 'btn font-weight-bold btn-default',
    },
    heightAuto: false,
  })
}

export const chekcInputSwal = (SwalContents) => {
  Swal.fire({
    title: '필수사항 입력',
    html: SwalContents,
    icon: 'info',
    heightAuto: false,
  }).then()
}

export const priceCheckSwal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  Swal.fire({
    title: '가격 입력',
    html: `직접 ${typeName}은 가격을 입력해야합니다.`,
    icon: 'info',
    heightAuto: false,
  }).then()
}

/* FullCalendar */
export const failedOrderSwal = (text, workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  Swal.fire({
    title: '정보',
    html: `해당 날짜는 ${text}이므로 ${typeName}이 불가능합니다.`,
    icon: 'info',
    heightAuto: false,
  }).then()
}
export const failedOrderSwalForToss = (text, workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  Swal.fire({
    title: '정보',
    html: `${text}이므로 ${typeName}이 불가능합니다.`,
    icon: 'info',
    heightAuto: false,
  }).then()
}
/* CalendarModal */
export const checkAuthInputSwal = () => {
  Swal.fire({
    title: '정보',
    html: '이름과 전화번호를 입력해주세요.',
    icon: 'info',
    heightAuto: false,
  }).then()
}

export const checkAuthPhoneSwal = () => {
  Swal.fire({
    title: '정보',
    html: '전화번호를 알맞게 입력해주세요.',
    icon: 'info',
    heightAuto: false,
  }).then()
}
export const checkAuthCheckBoxSwal = () => {
  Swal.fire({
    title: '정보',
    html: '개인정보 활용에 동의해주세요.',
    icon: 'info',
    heightAuto: false,
  }).then()
}

export const checkAuthPickUpDtmSwal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? '픽업' : WORK_TYPE_BOOKN
  Swal.fire({
    title: '정보',
    html: `${typeName} 날짜를 선택해주세요.`,
    icon: 'info',
    heightAuto: false,
  }).then()
}

export const authSwal = (workType = 'ORDER') => {
  const typeName = workType === 'ORDER' ? WORK_TYPE_ORDER : WORK_TYPE_BOOKN
  Swal.fire({
    title: '정보',
    html: `카카오톡으로 ${typeName}서 링크를 보냈습니다. <br/> 링크를 눌러 ${typeName}서작성을 완료해주세요!`,
    icon: 'info',
    iconHtml: '<img src="/media/svg/misc/kakaotalk-logo.svg" style="width:100px" />',
    heightAuto: false,
  }).then()
}
